// React
import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

// Mui
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import { MdLockOutline } from "react-icons/md";

// Components
import { ForgotPassword } from "./forgotPassword";
import logoEN from "../../../assets/logos/logoWhiteEN.png";
import logoFR from "../../../assets/logos/logoWhiteFR.png";

// Firebase
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../../firebase/firebase";

import { useFetchUser } from "../../../hooks/useFetchUser";

const Login: React.FC = () => {
    const hist = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const { currentAdmin, fetchingUser } = useFetchUser();

    // States
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [open, setOpen] = useState(false);

    const handleSubmit = async (e: any) => {
        try {
            e.preventDefault();
            await signInWithEmailAndPassword(auth, email, password);
        } catch (e) {
            console.error("onSubmit", e);
            if (e.code === "auth/user-not-found") enqueueSnackbar("User not found", { variant: "error" });
            else if (e.code === "auth/wrong-password") enqueueSnackbar("Wrong password", { variant: "error" });
            else if (e.code === "auth/invalid-email") enqueueSnackbar("Invalid email", { variant: "error" });
        }
    };

    if (fetchingUser) {
        return (
            <Backdrop open={fetchingUser} className="login__backdrop">
                <CircularProgress className="login__spinner" />
                <img src={localStorage.getItem("language") === "en" ? logoEN : logoFR} alt="" />
            </Backdrop>
        );
    }

    if (currentAdmin) {
        return <Redirect to="/dashboard" />;
    }

    return (
        <Container component="main" maxWidth="xs">
            <div className="dashboard__login__container">
                <Avatar className="login__avatar">
                    <MdLockOutline />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Login
                </Typography>
                <form noValidate onSubmit={handleSubmit}>
                    <TextField
                        id="email"
                        margin="normal"
                        label="Email"
                        variant="outlined"
                        type="text"
                        onChange={e => setEmail(e.currentTarget.value)}
                        required
                        fullWidth
                    />
                    <TextField
                        id="password"
                        margin="normal"
                        label="Password"
                        variant="outlined"
                        type="password"
                        onChange={e => setPassword(e.currentTarget.value)}
                        required
                        fullWidth
                    />

                    <Button type="submit" fullWidth variant="contained">
                        Log in
                    </Button>
                </form>
                <Grid container>
                    <Grid item xs></Grid>
                    <Grid item>
                        <Button onClick={() => setOpen(true)}>Forgot password?</Button>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs></Grid>
                    <Grid item>
                        <Button style={{ margin: 0 }} onClick={() => hist.push("/")}>
                            Return to portal
                        </Button>
                    </Grid>
                </Grid>
            </div>
            <ForgotPassword open={open} onClose={() => setOpen(false)} />
        </Container>
    );
};

export default Login;
